/* tslint:disable */
/* eslint-disable */
/**
 * CVAT REST API
 * REST API for Computer Vision Annotation Tool (CVAT)
 *
 * The version of the OpenAPI document: 2.31.0
 * Contact: support@cvat.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * * `random_uniform` - RANDOM_UNIFORM * `random_per_job` - RANDOM_PER_JOB * `manual` - MANUAL
 * @export
 * @enum {string}
 */

export const FrameSelectionMethod = {
    RandomUniform: 'random_uniform',
    RandomPerJob: 'random_per_job',
    Manual: 'manual'
} as const;

export type FrameSelectionMethod = typeof FrameSelectionMethod[keyof typeof FrameSelectionMethod];



